module.exports = __webpack_public_path__ + "static/media/mern-stack.1ff8dc61.jpg";